import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form'

import userActions from '../../context/users/actions';
import filesActions from '../../context/files/actions';
import { ToastContainer, notify } from '../../libraries/notifications';
import { isEmptyObject, composeValidators, validateIsfilled, validateOnlyNumber, capitalize, uuidv4, formatOnlyNumberInput, months, getObjectWithJsonDataToFormValues } from '../../libraries/utils';

import { history } from '../../routes';
import config from '../../config';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';
import TextInput from '../../components/forms/TextInput';
import SelectInput from '../../components/forms/SelectInput';
import internalsActions from '../../context/internals/actions';

import BirthDateInput from '../../components/forms/BirthDateInput';

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      submitting: false,
      signupData: {},
      files: {},
      preRegistered: false,
      loading: true,
    }
  }

  componentDidMount() {
    const params = this.props.match.params;
    if (params.hash) {
      this.getData(params);
    }
    else{
      if (isEmptyObject(this.props.location.state)) {
        history.push(config.ROUTES.HOME);
      } else {
        const { identification, identification_type } = this.props.location.state;
        this.getQuestions(identification, identification_type)
      }
    }
  }

  getData = async (params) => {
    await this.getUser(params);
    const { identification, identification_type } = this.state.signupData;
    await this.getQuestions(identification, identification_type);
  }

  getUser = async (params) => {
    console.log('GETTING USER');
    await this.props.onGetFromHash(params);
    console.log('AFTER GET');
    const error = this.props.user.error;
    if (error) {
      notify(this.t(error.message));
      history.push(config.ROUTES.HOME); // Si no lo encuentra no existe el usuario, entonces debe salir
    } else {
      const user = getObjectWithJsonDataToFormValues(this.props.user.item, ['id', 'first_name', 'last_name', 'phone', 'email','identification_type','identification','insurance','insurance_number', 'birth_date']);
      user.birth_date = new Date(user.birth_date);
      this.setState({ signupData: user, preRegistered: true, });
    }
  }

  getQuestions = async (identification, identification_type) => {
    await this.props.onGetQuestions({ identification: identification })
    //console.log(this.props.internals.error)//this.props.internals.resultado["Novedad"]
    const internals_error = this.props.internals.error;
    if (internals_error) {
      notify(this.t(internals_error.message + " "));
      this.setState({ "error": internals_error.message })
    } else {
      //console.log("this.props.internals", this.props.internals)
      const { Desafios, IdConsulta, Novedad, Estado, Persona } = this.props.internals.questions

      if (Estado !== 200) {
        this.setState({ "error": `Error: ${Novedad}` })
        //this.setState({ user });
        return
      }

      let first_name = Persona.RazonSocial.split(",")[1]
      let last_name = Persona.RazonSocial.split(",")[0]
      if(first_name){
        first_name = first_name.trim()
      }
      if(last_name){
        last_name = last_name.trim()
      }
      //let birthdate = new Date(Persona.FechaNacimiento+" 00:00")
      let gender = Persona.Sexo == "M" ? "masculino" : "femenino"
      let birth_date = new Date(Persona.FechaNacimiento + "T00:00")

      let signupData = { ...this.state.signupData, first_name, last_name, identification, gender, birth_date, identification_type }
      this.setState({ desafios: Desafios, id_consulta: IdConsulta, signupData, loading: false })
    }
  }

  gotoBack = async () => {
    history.push(config.ROUTES.USER.INFO);
  }

  onSubmit = async (values) => {
    const { signupData } = this.state;
    this.setState({ submitting: true });
    history.push({
      pathname: config.ROUTES.VERIFICATION, state: {
        identification: values.identification,
        valuesFromVerification: signupData,
        desafios: this.state.desafios,
        id_consulta: this.state.id_consulta,
        preRegistered: this.state.preRegistered,
      }
    });
  }

  onTerms = () => {
    history.push(config.ROUTES.TERMS);
  }

  onLogin = () => {
    history.push(config.ROUTES.LOGIN);
  }

  onClearImageField = ({ name }) => {
    console.log('CLEAR IMAGE FIELD:', name);
    if (name) this.setState({ files: { ...this.state.files, [name]: null } });
  }

  onFileChange = async ({ file, data, name }) => {
    this.setState({ submitting: true });

    data.append("identifier", `${uuidv4()}_${name}`)
    await this.props.onPictureUpload(data);
    console.log('FILES', this.props.files);
    const error = this.props.files.error;
    console.log('UPLOADED');
    if (error) {
      notify(this.t(error.message));
    } else {
      console.log("UPLOADED", this.props.files)
      this.setState({ files: { ...this.state.files, [name]: this.props.files.files.fileInfo.location } })
    }
    this.setState({ submitting: false });
    return this.props.files.files.fileInfo.location
  }

  render() {
    const { signupData, files } = this.state;
    
    const required = value => (validateIsfilled(value) ? undefined : this.t("This field is required"))
    //const required_date = value => (isDate(value) ? undefined : this.t("This field is required"))
    //const email = value => (validateEmail(value) ? undefined : this.t("Not a valid email"))
    const onlynumber = value => (validateOnlyNumber(value) ? undefined : this.t("El documento solo debe llevar digitos"))
    const dnilength = value => (value.length >= 7 && value.length <= 8 ? undefined : this.t("EL documento debe tener 7 u 8 numeros"))

    const dni_types = config.OPTIONS.SINGUP.IDENTIFICATION.TYPES.map((o) => { return { value: o, label: this.t(o) } });
    const gender_types = config.OPTIONS.SINGUP.GENDER.TYPES.map((o) => { return { value: o, label: capitalize(o) } });

    const today = new Date()
    let years = [...Array(today.getFullYear() + 1).keys()].slice(1915, today.getFullYear() + 1).map(x => { return { label: x, value: x } })
    years.reverse()
    const months_arr = [...Array(13).keys()].slice(1, 13).map(x => { return { label: capitalize(months(x - 1).slice(0, 3)), value: x } })
    const days = [...Array(32).keys()].slice(1, 32).map(x => { return { label: x, value: x } })

    return (
      <LayoutSmall
        main={{ className: "bg-base-200 text-primary bg-pattern" }}
        header={{
          title: this.t("Register"),
          className: "!bg-transparent !text-primary",
          left: { icon: 'arrow_left', action: () => this.gotoBack() },
        }}
        container={{
          className: "mt-5",
        }}
        loading={this.state.loading}
      >
        <ToastContainer />

        {!this.state.error && <Form
          initialValues={signupData || {}}
          onSubmit={this.onSubmit}
        >
          {({ handleSubmit, submitting, pristine, values, }) => (
            <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto px-4">
              <div className="flex justify-center">{this.t("Informacion Personal")}</div>
              <p className='text-base-content mt-1 mb-5 text-center'>Si esta información es incorrecta chequear DNI en paso anterior.</p>
              <div className="flex">

                <div className="w-1/3 mr-3">
                  <Field name="identification_type" component={SelectInput} placeholder={this.t("Tipo")} label={this.t("Tipo de Doc.")} validate={required}
                    options={dni_types}
                    readOnly
                    empty={this.t("Seleccione")}
                  />
                </div>
                <div className="w-2/3">
                  <Field name="identification" parse={v => formatOnlyNumberInput(v, 8)} component={TextInput} placeholder={this.t("Nro de Documento")} label={this.t("Nro de Documento")} validate={composeValidators(required, onlynumber, dnilength)} readOnly />
                </div>
              </div>
              <div className="w-full">
                <Field name="first_name" component={TextInput} placeholder={this.t("Ej. Juan")} label={this.t("Nombre")} validate={required} readOnly />
              </div>
              <div className="w-full">
                <Field name="last_name" component={TextInput} placeholder={this.t("Ej. Sosa")} label={this.t("Apellido")} validate={required} readOnly />
              </div>


              <div className="flex">
                <div className="w-1/2 mr-3">
                  <Field name="gender" component={SelectInput} placeholder={this.t("Genero")} label={this.t("Género")} validate={required}
                    options={gender_types}
                    empty={this.t("Seleccione")}
                    readOnly
                  />
                </div>

                {/*<div className="w-1/2">
                  <Field name="birth_date" component={DatepickerInputCalendar} locale="es" placeholder={this.t("dd/mm/aaaa")} label="Fecha de Nacimiento" validate={required_date} readOnly={true} onClick={this.openModalDate}/>
                </div>*/}
              </div>

              <div className="">

                {this.state.signupData && <Field
                  name="birthdate"
                  component={BirthDateInput}
                  label={this.t("Fecha de nacimiento")}
                  initialValue={signupData.birth_date}
                  allowNull={true}
                  readOnly
                />}
              </div>


              <div className="w-full mt-5">
                <Button
                  className="btn-primary btn-block"
                  title={this.t("Next")}
                  onClick={handleSubmit}
                  disabled={this.state.submitting}
                />
              </div>

            </form>

          )}
        </Form>}
        {this.state.error &&
          <div className="w-full max-w-lg mx-auto px-4">
            <p>Ocurrió un error. Chequee que el DNI ingresado sea válido.</p>
            <div className="w-full mt-5">
              <Button
                className="btn-primary btn-block"
                title={this.t("Volver")}
                onClick={() => { history.push(config.ROUTES.USER.INFO) }}

              />
            </div>
          </div>}
      </LayoutSmall>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.users.current,
    files: state.files,
    internals: state.internals,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onRegister: (params) => dispatch(userActions.saveOrUpdate(params, 'register')),
    onPictureUpload: (params) => dispatch(filesActions.upload(params)),
    onGetQuestions: (params) => dispatch(internalsActions.postQuestions(params)),
    onGetFromHash: (params) => dispatch(userActions.getFromHash(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Signup));
